<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/GAU1vZ/tc-custom/9798889101895.jpg?1705688258616" alt="This image is the cover for the book Shadows of Death"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Shadows of Death
      </h1>
      <p class="bookDescription body article font2">
        <p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;font-size:16px;font-family:"Bierstadt",sans-serif;'>Prepare to bear witness as the inexorable hand of fate deals its cards to unsuspecting victims within the gripping pages of this macabre collection. In nineteen chilling tales of horror, the veil between the ordinary and the extraordinary is torn asunder. Venture into a southern town where a living corpse holds sway over every aspect of daily life. Dare to step foot into a cemetery where the shadows live and beckon the curious to their fate. Beware the allure of a mysterious box whose contents possess a power that turns those who gaze upon it into stone.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Frederick Pangbourne
      </h2>
      
      <p class="authorDescription body article"><p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'><span style='font-family:"Times New Roman",serif;'>Frederick Pangbourne is a short story and horror author with five anthologies currently out in publication. His stories have been featured in numerous magazines, anthologies, and on podcasts. A former Marine Corps veteran and retired correctional officer, he now resides in Florida where he continues to write and relax.</span></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?510eda30